import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import _ from "lodash";
import parse from "html-react-parser";
import {
  fetchBill,
  fetchBillProposals,
  billsSelector,
} from "../_redux/billsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import BillAuthor from "../components/BillAuthor/BillAuthor";

interface ParamTypes {
  id: string;
}

function ProposalsReport() {
  const dispatch = useDispatch();
  const { billProposals, currentBill } = useSelector(billsSelector);
  const { id: billId } = useParams<ParamTypes>();

  const [billName, setBillName] = useState("");
  const [paragraphs, setParagraphs] = useState([]);

  useEffect(() => {
    if (!billId) dispatch(fetchBill(billId));
  }, [billId]);

  useEffect(() => {
    if (!currentBill) dispatch(fetchBillProposals(+billId));
  }, [currentBill]);

  useEffect(() => {
    if (billProposals) {
      setBillName(billProposals.billName);
      const _paragraphs = _(billProposals.data)
        .groupBy("text")
        .map(function (items, text) {
          const words = text.split(" ");
          const slicedWords = words.slice(
            0,
            words.length < 5 ? words.length : 5
          );
          return {
            text:
              items?.length && items[0].element
                ? parse(items[0].element)
                : text,
            slicedText: slicedWords.join(" "),
            proposals: items,
          };
        })
        .value();

      setParagraphs(_paragraphs);
    }
  }, [billProposals]);

  return paragraphs?.length ? (
    <>
      <h1 style={{ fontWeight: "bold" }}>{billName}</h1>

      {paragraphs.map((item) => (
        <Card id={item.slicedText.replace(" ", "")} className="mb-5">
          <Card.Body>
            <p>{item.text}</p>
            {item.proposals.map((p, i) => (
              <Card className="mb-3">
                <Card.Body>
                  <div className="d-flex">
                    <BillAuthor author={p.team?.name} />
                    <p className="p-2">{p.content}</p>
                  </div>
                </Card.Body>
              </Card>
            ))}
          </Card.Body>
        </Card>
      ))}
    </>
  ) : (
    <div>
      <FormattedMessage id="BILL.PROPOSALS.REPORT.NO_PROPOSALS" />
    </div>
  );
}

export default ProposalsReport;
